// Module
var code = "<button data-ng-hide=\"$ctrl.disabled\" type=\"button\"\n        class=\"tw-text-sm tw-text-yellow hover:tw-text-yellow-lighter focus:tw-outline-none\"\n        aria-label=\"Add bicycles\" data-ng-click=\"$ctrl.add($event)\">\n    <i class=\"tw-text-sm fa fa-plus\"></i> Add bicycles\n</button>";
// Exports
module.exports = code;